import React, { Component } from "react";

class PageHeader extends Component {
    render() {
        return (
            <div className="cm-page-header overlay-dark bg-cover" style={{ backgroundImage: "url(assets/images/Balls.jpg)" }}>
                <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="block text-white text-center">
                                <h2 className="h1">{this.props.title}</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PageHeader;